import React, { ReactNode } from 'react'
import { useIntl } from 'gatsby-plugin-react-intl'
import * as styles from './Intro.module.scss'
import Cta from '../cta/Cta'

const Intro: React.FC = () => {
  const t = useIntl()

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>
        {t.formatMessage({ id: 'intro.title' }, {
          highlight: (content: ReactNode) => (<span className={styles.highlight}>{content}</span>)
        })}
      </h1>
      <div className={styles.subtitle}>
        {t.formatMessage({ id: 'intro.subtitle' })}
      </div>
      <div className={styles.startPlaying}>
        <Cta
          dataTest='Start-onboarding'
          content={t.formatMessage({ id: 'intro.cta' })}
          className={styles.cta}
        />
      </div>
      <div className={styles.discover}>
        {t.formatMessage({ id: 'intro.discover' })}
      </div>
    </div>
  )
}

export default Intro
